import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Button, Grid, Link, Typography } from "@mui/material";
import Hero from "../../components/layout/Hero";
import {
  BCPSearch,
  BCPArrowRightFromBracket,
} from "../../components/icons/bcp/BCPIcons";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function HomeSoulMasters() {
  const authContext = useContext(AuthContext);
  return (
    <>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/hero1.jpg`}
        backgroundTint={
          "linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3))"
        }
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "600px"],
          minHeight: "unset",
          color: "common.white",
        }}
      >
        <Typography variant="h1" align="left" color="inherit" paragraph>
          Battle Arenas Await!!!!!!!!
        </Typography>
        <Box sx={{ marginBottom: 4 }}>
          <Grid container spacing={2} justifyContent="left">
            <Grid item>
              <Button
                href="/play/events"
                variant="contained"
                color="primary"
                startIcon={<BCPSearch />}
              >
                Find an Event
              </Button>
            </Grid>
            {!authContext?.authState?.isAuthenticated ? (
              <Grid item>
                <Button
                  href="/login"
                  variant="contained"
                  color="secondary"
                  startIcon={<BCPArrowRightFromBracket />}
                >
                  Login
                </Button>
              </Grid>
            ) : (
              <Grid item>
                <Button
                  focusRipple
                  href="/subscription"
                  variant="contained"
                  color="success"
                >
                  Subscribe
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      </Hero>
      <FeaturedEvents />
      <HighlightedEvents />

      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/hero2.jpg`}
        backgroundTint
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Welcome Gladiators!!!!!!
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              The Best Coast Pairings app for Soul Masters TCG is a player's
              portal to casual and competitive events. Using the player app you
              can search for, browse and register for competitive events. Also
              see table assignments, pairings and view placings for any ongoing
              events. Players who are participating in the event can securely
              check in and submit score results.
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              <Link
                href={
                  authContext?.authState?.identity?.subscriber
                    ? "/account"
                    : "/subscription/player"
                }
                underline="none"
                sx={{
                  color: "green",
                }}
              >
                Subscribe
              </Link>{" "}
              and see any submitted deck list or Rankings for any event
              worldwide.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12],
            }}
          >
            <Box sx={{ marginBottom: 4 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"],
                }}
              >
                {!authContext?.authState?.identity?.subscriber && (
                  <Grid item xs={12}>
                    <Button
                      focusRipple
                      style={{
                        width: "150px",
                        height: "44px",
                      }}
                      href="/subscription/player"
                      variant="contained"
                      color="success"
                    >
                      Subscribe
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
